import {Guess} from './guess';

export class Game {
  id: string;
  secretCode: string;
  guesses: Guess[];
}
